<template>
  <div class="flip-wrap" :class="{ flipped }">
    <div class="flipper">
      <section class="face front" :inert="flipped ? '' : null">
        <slot name="front" />
      </section>
      <section class="face back" :inert="flipped ? null : ''">
        <slot name="back" />
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XSFlipCard',
  props: {
    flipped: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.flip-wrap {
  perspective: 1200px;
  position: relative;
}
.flipper {
  position: relative;
  transform-style: preserve-3d;
  transition: transform 280ms ease;
}
.flip-wrap.flipped .flipper {
  transform: rotateY(180deg);
}
.face {
  backface-visibility: hidden;
}
.front,
.back {
  position: relative;
  min-height: 40px;
}
.back {
  position: absolute;
  inset: 0;
  transform: rotateY(180deg);
}
@media (prefers-reduced-motion: reduce) {
  .flipper {
    transition: none;
  }
}
</style>
